import React, {useContext, useEffect, useState} from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";

const IngredientsRowTotal = ({responseIndex}) => {

    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById] = byId
    const [total, setTotal] = useState(0)


    useEffect(() => {

        let item = recipeById.billOfMaterials[responseIndex]
        if ( item.stock ){
            setTotal(item.parity * item.amount * item.unitPrice)
        }
    }, [recipeById])

    return(
        <React.Fragment>
            <span>{new Intl.NumberFormat().format(total)}</span>
        </React.Fragment>
    )
}
export default IngredientsRowTotal